import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';
import { fetchNotifications, addNotification } from '../store/notificationSlice';
import notificationService from '../services/notificationService';

const POLL_INTERVAL = 30000; // Poll every 30 seconds

export const useNotifications = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.auth);
  const { notifications, unreadCount } = useSelector((state: RootState) => state.notifications);

  // Request desktop notification permission on mount
  useEffect(() => {
    if (user) {
      notificationService.requestNotificationPermission();
    }
  }, [user]);

  // Poll for new notifications
  useEffect(() => {
    if (!user) return;

    // Fetch notifications immediately
    dispatch(fetchNotifications({ limit: 10 }) as any);

    // Set up polling
    const intervalId = setInterval(() => {
      dispatch(fetchNotifications({ limit: 10 }) as any);
    }, POLL_INTERVAL);

    return () => {
      clearInterval(intervalId);
    };
  }, [user, dispatch]);

  // Show desktop notification for new unread notifications
  useEffect(() => {
    if (!user || !notifications.length) return;

    const latestNotification = notifications[0];

    // Check if it's a new notification (created within the last minute)
    const isNew = new Date().getTime() - new Date(latestNotification.createdAt).getTime() < 60000;

    if (isNew && !latestNotification.isRead) {
      notificationService.showDesktopNotification(
        'New Notification',
        {
          body: latestNotification.message,
          icon: '/logo192.png', // Make sure you have a logo in your public folder
          badge: '/logo192.png',
          tag: latestNotification._id,
        }
      );
    }
  }, [notifications, user]);

  return {
    notifications,
    unreadCount,
  };
};
